export const GET_ROLES = 'GET_ROLES';
export const SIGN_UP = 'SIGN_UP';